import {firebaseAuth} from "./firebase";

class Auth {

    trySignInWithEmailAndPassword = async (email, password) => {
        const currentUser = await firebaseAuth.signInWithEmailAndPassword(email, password);
        localStorage.setItem("currentUser", JSON.stringify(currentUser));
        return currentUser;
    };

    trySignOut = () => {
        return firebaseAuth.signOut()
            .then(() => {
                localStorage.removeItem("currentUser");
            }).catch((error) => {
                console.log(error.message)
            });
    };

    tryGetCurrentUser = () => {
        return localStorage.getItem("currentUser");
    }

}

const auth = new Auth();
export default auth

